import { useEffect, useState } from 'react';

import { useManagedRouter } from 'src/hooks/useAppRouter';
import useUser from 'src/hooks/useUser';

type SignInVisitorInfos = {
    email?: string;
    firstName?: string;
    lastName?: string;
};

export const useSignInVisitor = () => {
    const { router } = useManagedRouter();
    const user = useUser();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [infos, setInfos] = useState<SignInVisitorInfos>();

    useEffect(() => {
        const processSiv = () => {
            if (router.query.siv === 'true' && !user) {
                setIsModalOpen(true);
                setInfos({
                    email: router.query.e as string | undefined,
                    firstName: router.query.f as string | undefined,
                    lastName: router.query.n as string | undefined,
                });
            }
        };

        // Wait 2 seconds to make sure the web app is fully loaded with ther user and all the other necessary data
        // It also makes appearance of the modal smoother and less aggressive
        setTimeout(() => {
            processSiv();
        }, 2000);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.query.siv]);

    return {
        isModalOpen,
        infos,
        closeModal: () => setIsModalOpen(false),
    };
};
